<template>
  <div class="flex flex-col w-full gap-4 py-2 animate-pulse" aria-hidden="true">
    <div class="w-1/3 h-4 rounded bg-n-alpha-1" />
    <div class="w-full h-24 rounded-xl bg-n-alpha-1" />
    <div class="w-full h-24 rounded-xl bg-n-alpha-1" />
    <div class="w-2/3 h-4 rounded bg-n-alpha-1" />
  </div>
</template>
